module.exports = __webpack_public_path__ + "static/media/30.7f3a9b3f.jpg";